import { render, staticRenderFns } from "./ItemView.vue?vue&type=template&id=39a253e9&scoped=true&"
import script from "./ItemView.vue?vue&type=script&lang=js&"
export * from "./ItemView.vue?vue&type=script&lang=js&"
import style0 from "./ItemView.vue?vue&type=style&index=0&id=39a253e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a253e9",
  null
  
)

export default component.exports